import { render, staticRenderFns } from "./FormDesignModel.vue?vue&type=template&id=26991b95&scoped=true"
import script from "./FormDesignModel.vue?vue&type=script&lang=js"
export * from "./FormDesignModel.vue?vue&type=script&lang=js"
import style0 from "./FormDesignModel.vue?vue&type=style&index=0&id=26991b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26991b95",
  null
  
)

export default component.exports